<template>
  <span class="tw-flex tw-items-center tw-gap-1">
    <template v-if="confirming">
      <span class="tw-text-xs tw-text-gray-500">Verwijderen?</span>

      <button
        type="button"
        aria-label="Verwijderen bevestigen"
        class="tw-cursor-pointer tw-text-primary"
        @click="confirm"
      >
        <q-icon name="fa-solid fa-check" size="12px" />
      </button>

      <button
        type="button"
        aria-label="Verwijderen annuleren"
        class="tw-cursor-pointer tw-text-gray-400"
        @click="confirming = false"
      >
        <q-icon name="fa-solid fa-xmark" size="12px" />
      </button>
    </template>

    <button
      v-if="!confirming"
      type="button"
      aria-label="Verwijderen"
      class="tw-cursor-pointer tw-text-gray-400 hover:tw-text-negative"
      @click="confirming = true"
    >
      <q-icon :name="toClassicIcon(deleteIcon)" />
    </button>
  </span>
</template>

<script setup lang="ts">
import { deleteIcon, toClassicIcon } from "common/defaultIcons";
import { ref } from "vue";

const emit = defineEmits<{ confirm: [] }>();
const confirming = ref(false);

const confirm = (): void => {
  confirming.value = false;
  emit("confirm");
};
</script>
